module.exports = __webpack_public_path__ + "media/images/very_unlikely_smiley-823fa012226ac84dbc08b7b1a95f3546.svg";